import { useTranslation } from 'react-i18next';
import { RegistryEpisodeSummary } from '../../../types';

interface EpisodesTabProps {
  episodes: RegistryEpisodeSummary[];
}

export default function EpisodesTab({ episodes }: EpisodesTabProps) {
  const { t } = useTranslation('scriptSummary');

  return (
    <div className="registry-table-wrapper">
      <table className="registry-table">
        <thead>
          <tr>
            <th style={{ width: '5%' }}>{t('episodes.episodeNo')}</th>
            <th style={{ width: '55%' }}>{t('episodes.summary')}</th>
            <th style={{ width: '20%' }}>{t('episodes.keyCharacters')}</th>
            <th style={{ width: '20%' }}>{t('episodes.keyScenes')}</th>
          </tr>
        </thead>
        <tbody>
          {episodes.map((ep) => (
            <tr key={ep.episode}>
              <td className="registry-table-ep">{ep.episode}</td>
              <td className="registry-table-summary">{ep.summary}</td>
              <td>
                <div className="registry-tag-row">
                  {ep.key_characters.map((name) => (
                    <span key={name} className="registry-tag">{name}</span>
                  ))}
                </div>
              </td>
              <td>
                <div className="registry-tag-row">
                  {ep.key_scenes.map((name) => (
                    <span key={name} className="registry-tag">{name}</span>
                  ))}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
